import { addSeconds } from 'date-fns';

export const setInStorage = (name: string, value: string) => {
	localStorage.setItem(name, value);
};

export const removeFromStorage = (name: string) => {
	localStorage.removeItem(name);
};

export const getInStorage = (name: string) => {
	return localStorage.getItem(name);
};

export const setTimerInStorage = (seconds: number, storageName: string) => {
	const end = addSeconds(new Date(), seconds);
	setInStorage(storageName, `${end}`);
};
